import { useEffect, type ReactNode } from 'react';

interface DrawerScrimProps {
  width?: number;
  children: ReactNode;
  onClose: () => void;
  labelledBy?: string;
}

/** Right-side drawer with a half-opaque scrim. Used by the Invite drawer. */
export default function DrawerScrim({
  width = 460,
  children,
  onClose,
  labelledBy,
}: DrawerScrimProps) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="nb-drawer-scrim-enter fixed inset-0 z-50 flex justify-end"
      style={{ background: 'rgba(15, 25, 18, 0.35)' }}
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        className="nb-drawer-enter bg-white dark:bg-[#1a1f1c] h-full flex flex-col overflow-hidden shadow-2xl"
        style={{ width, maxWidth: '100%' }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
